import { render, staticRenderFns } from "./Trashbin.vue?vue&type=template&id=758970bc&scoped=true"
import script from "./Trashbin.vue?vue&type=script&lang=js"
export * from "./Trashbin.vue?vue&type=script&lang=js"
import style0 from "./Trashbin.vue?vue&type=style&index=0&id=758970bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758970bc",
  null
  
)

export default component.exports